module.exports = __webpack_public_path__ + "img/resume.315bf116.svg";